import { Route } from '@angular/router';
import { reportsEnabledGuard } from '@core/security/guards/reports-flag.guard';
import { subscriptionGuard } from '@core/security/guards/subscription.guard';

/**
 * `/reclutador/reportes`, mounted among the children of the `reclutador` skeleton (`authGuard`).
 * The flag decides whether the route exists at all (`canMatch`); a live subscription decides
 * whether the recruiter may enter (`canActivate`), the same gate as the other product pages. The
 * pages, the facade and their copy stay in the lazy `REPORTES_ROUTES` chunk.
 */
export const REPORTES_ENTRY_ROUTE: Route = {
  path: 'reportes',
  canMatch: [reportsEnabledGuard],
  canActivate: [subscriptionGuard],
  loadChildren: () => import('./reportes.routes').then((m) => m.REPORTES_ROUTES),
};
